
(function() {
  // ══════════════════════════════════════════════════════
  // SYSTÈME DE NOTIFICATIONS
  // ══════════════════════════════════════════════════════

  const STORAGE_KEY = 'mz-notifications';
  const READ_KEY    = 'mz-notif-read';

  // ── Chargement notifications depuis storage ──
  async function loadNotifications() {
    try {
      const result = await window.storage?.get(STORAGE_KEY, true);
      if (result && result.value) return JSON.parse(result.value);
    } catch(e) {}
    return [];
  }

  // ── Sauvegarde notifications ──
  async function saveNotifications(notifs) {
    try {
      await window.storage?.set(STORAGE_KEY, JSON.stringify(notifs), true);
    } catch(e) {}
  }

  // ── IDs lus (localStorage user) ──
  function getReadIds() {
    try { return JSON.parse(localStorage.getItem(READ_KEY) || '[]'); } catch(e) { return []; }
  }
  function markAsRead(id) {
    const ids = getReadIds();
    if (!ids.includes(id)) { ids.push(id); localStorage.setItem(READ_KEY, JSON.stringify(ids)); }
  }

  // ── Rendu liste : les items sont déjà dans le HTML via Liquid ──
  function renderList() {
    const list = document.getElementById('mzNotifList');
    if (!list) return;
    const readIds = getReadIds();
    list.querySelectorAll('.mz-notif-item').forEach(item => {
      const id = item.getAttribute('data-id');
      if (readIds.includes(id)) item.classList.remove('unread');
      item.addEventListener('click', () => {
        const notif = JSON.parse(item.getAttribute('data-notif').replace(/&#39;/g, "'"));
        markAsRead(id);
        item.classList.remove('unread');
        updateDot(list.querySelectorAll('.mz-notif-item.unread').length);
        openDetail(notif);
      });
    });
    const unread = list.querySelectorAll('.mz-notif-item.unread').length;
    updateDot(unread);
  }

  // ── Badge point orange ──
  function updateDot(count) {
    const dot = document.getElementById('mzNotifDot');
    if (!dot) return;
    /* 2026-08-25 - MESURE SUR MOBILE : la pastille apparaissait a 94 ms, DISPARAISSAIT
       a 660 ms puis revenait a 1015 ms. Cause : updateDot etait appele avec 0 pendant
       que la liste des notifications etait reconstruite - un zero TRANSITOIRE, pas un
       vrai zero. On ignore donc un 0 tant qu'aucune notification n'existe dans le DOM.
       Et on pilote la classe .alm-on (voir <style id="alm-notif-dot-20260825">) au lieu
       d'ecrire style.display, pour rester coherent avec l'etat pose au chargement. */
    if (count === 0 && document.querySelectorAll('.mz-notif-item').length === 0) return;
    dot.style.removeProperty('display');
    if (count > 0) {
      dot.textContent = count > 9 ? '9+' : count;
      dot.classList.add('alm-on');
    } else {
      dot.classList.remove('alm-on');
    }
  }

  // ── Ouvrir panel ──
  const panel   = document.getElementById('mzNotifPanel');
  const overlay = document.getElementById('mzNotifOverlay');
  const btn     = document.getElementById('mzNotifBtn');
  const closeBtn = document.getElementById('mzNotifPanelClose');

  function openPanel() {
    panel?.classList.add('open');
    overlay?.classList.add('open');
    document.body.style.overflow = 'hidden';
    renderList();
  }
  function closePanel() {
    panel?.classList.remove('open');
    overlay?.classList.remove('open');
    closeDetail();
    document.body.style.overflow = '';
  }

  btn?.addEventListener('click', (e) => {
    e.stopPropagation();
    panel?.classList.contains('open') ? closePanel() : openPanel();
  });
  closeBtn?.addEventListener('click', closePanel);
  overlay?.addEventListener('click', closePanel);

  // ── Vue détail ──
  const detail = document.getElementById('mzNotifDetail');
  const detailBack = document.getElementById('mzNotifDetailBack');
  const detailContent = document.getElementById('mzNotifDetailContent');

  function openDetail(notif) {
    if (!detail || !detailContent) return;
    detailContent.innerHTML = `
      ${notif.image
        ? `<img class="mz-notif-detail-img" src="${notif.image}" alt="${notif.title}">`
        : `<div class="mz-notif-detail-img-placeholder"><svg viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="18" rx="3"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg></div>`
      }
      <div class="mz-notif-detail-body">
        <div class="mz-notif-detail-title">${notif.title}</div>
        ${notif.desc ? `<div class="mz-notif-detail-text">${notif.desc}</div>` : ''}
        ${notif.url ? `<a href="${notif.url}" class="mz-notif-detail-cta">${notif.cta || 'Découvrir'}</a>` : ''}
      </div>
    `;
    panel?.classList.remove('open');
    detail.classList.add('open');
  }
  function closeDetail() {
    detail?.classList.remove('open');
  }
  detailBack?.addEventListener('click', () => {
    closeDetail();
    panel?.classList.add('open');
  });

  // ── Initialisation : dot au chargement ──
  (function() {
    const items = document.querySelectorAll('.mz-notif-item');
    const readIds = getReadIds();
    let unread = 0;
    items.forEach(item => {
      const id = item.getAttribute('data-id');
      if (!readIds.includes(id)) unread++;
      else item.classList.remove('unread');
    });
    updateDot(unread);
  })();

  // ── ADMIN : publier une notification ──
  const adminBtn  = document.getElementById('mzNotifAdminBtn');
  const adminForm = document.getElementById('mzNotifAdminForm');
  const publishBtn = document.getElementById('mzAdminPublish');
  const clearBtn  = document.getElementById('mzAdminClear');
  const success   = document.getElementById('mzAdminSuccess');

  adminBtn?.addEventListener('click', () => {
    adminForm?.classList.toggle('open');
  });

  publishBtn?.addEventListener('click', async () => {
    const title = document.getElementById('mzAdminTitle')?.value?.trim();
    const desc  = document.getElementById('mzAdminDesc')?.value?.trim();
    const img   = document.getElementById('mzAdminImg')?.value?.trim();
    const url   = document.getElementById('mzAdminUrl')?.value?.trim();
    const cta   = document.getElementById('mzAdminCta')?.value?.trim();

    if (!title || !url) {
      alert('Le titre et l\'URL sont obligatoires.');
      return;
    }

    const notifs = await loadNotifications();
    const newNotif = {
      id: Date.now().toString(),
      title,
      desc,
      image: img || '',
      url,
      cta: cta || 'Découvrir',
      date: new Date().toISOString()
    };
    notifs.unshift(newNotif);
    await saveNotifications(notifs);

    ['mzAdminTitle','mzAdminDesc','mzAdminImg','mzAdminUrl','mzAdminCta'].forEach(id => {
      const el = document.getElementById(id);
      if (el) el.value = '';
    });

    if (success) { success.classList.add('show'); setTimeout(() => success.classList.remove('show'), 3000); }
    updateDot(notifs.filter(n => !getReadIds().includes(n.id)).length);
  });

  clearBtn?.addEventListener('click', async () => {
    if (!confirm('Supprimer toutes les notifications ?')) return;
    await saveNotifications([]);
    localStorage.removeItem(READ_KEY);
    updateDot(0);
    if (success) { success.textContent = '✓ Supprimées !'; success.classList.add('show'); setTimeout(() => { success.classList.remove('show'); success.textContent = '✓ Notification publiée !'; }, 2000); }
  });

})();
